export const ASSET_TYPE_LIST= 'ASSET_TYPE_LIST';
export const ASSET_TYPE_LIST_SUCCESS = 'ASSET_TYPE_LIST_SUCCESS';
export const ASSET_TYPE_LIST_ERROR = 'ASSET_TYPE_LIST_ERROR';

export const ADD_ASSET_TYPE = 'ADD_ASSET_TYPE';
export const ADD_ASSET_TYPE_SUCCESS = 'ADD_ASSET_TYPE_SUCCESS';
export const ADD_ASSET_TYPE_ERROR = 'ADD_ASSET_TYPE_ERROR';

export const EDIT_ASSET_TYPE = 'EDIT_ASSET_TYPE';
export const EDIT_ASSET_TYPE_SUCCESS = 'EDIT_ASSET_TYPE_SUCCESS';
export const EDIT_ASSET_TYPE_ERROR = 'EDIT_ASSET_TYPE_ERROR';

export const ASSET_TYPE_DETAILS = 'ASSET_TYPE_DETAILS';
export const ASSET_TYPE_DETAILS_SUCCESS =  'ASSET_TYPE_DETAILS_SUCCESS';
export const ASSET_TYPE_DETAILS_ERROR = 'ASSET_TYPE_DETAILS_ERROR';

export const DELETE_ASSET_TYPE = 'DELETE_ASSET_TYPE';
export const DELETE_ASSET_TYPE_SUCCESS = 'DELETE_ASSET_TYPE_SUCCESS';
export const DELETE_ASSET_TYPE_ERROR  = 'DELETE_ASSET_TYPE_ERROR';

export const ADD_QUESTION = 'ADD_QUESTION';
export const ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS';
export const ADD_QUESTION_ERROR = 'ADD_QUESTION_ERROR';

export const QUESTION_LIST = 'QUESTION_LIST';
export const QUESTION_LIST_SUCCESS = 'QUESTION_LIST_SUCCESS';
export const QUESTION_LIST_ERROR = 'QUESTION_LIST_ERROR';

export const QUESTION_DETAILS = 'QUESTION_DETAILS';
export const QUESTION_DETAILS_SUCCESS = 'QUESTION_DETAILS_SUCCESS';
export const QUESTION_DETAILS_ERROR = 'QUESTION_DETAILS_ERROR';

export const DELETE_QUESTION = 'DELETE_QUESTION';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';
export const DELETE_QUESTION_ERROR = 'DELETE_QUESTION_ERROR';


